export default __webpack_public_path__ + "static/media/slogan.434a20f1.png";